import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  async getProjects (clientId) {
    try {
      const { data } = await httpClient.get(`/${clientId}/projects`)
      return data
    } catch (e) {
      console.error(`Can't fetch API tokens. Error: ${e.message}`)
      throw new Error('Cannot fetch api tokens from API')
    }
  },
  async createProject (clientId, name) {
    try {
      const { data } = await httpClient.post(`/${clientId}/projects`, name)
      return data
    } catch (e) {
      console.error(`Can't create new API token. Error: ${e.message}`)
      throw new Error('Cannot create new API token')
    }
  },
  async updateProject (clientId, { name, projectId }) {
    try {
      const { data } = await httpClient.patch(`/${clientId}/projects/${projectId}`, name)
      return data
    } catch (e) {
      console.error(`Can't create new API token. Error: ${e.message}`)
      throw new Error('Cannot create new API token')
    }
  },
  async deleteProject (clientId, projectId) {
    try {
      await httpClient.get(`/${clientId}/projects/${projectId}/delete`)
    } catch (e) {
      console.error(`Can't delete API token. Error: ${e.message}`)
      throw new Error('Cannot delete api token from API')
    }
  }
}
